import { useEffect, useState } from 'react';
import '../../../css/SoccerTeamHomePage.css';
import ScheduleBox from '../../../components/ScheduleBox';
import RecentBox from '../../../components/RecentBox';
import RosterBox from '../../../components/RosterBox';
import PLsoccerLogos from '../../../assets/PLsoccerLogos';
import Record from '../../../components/Record';

const BournemouthHome = () => {
    const [isTeamFavorite, setIsTeamFavorite] = useState(false);
    const [starredPlayers, setStarredPlayers] = useState([]);
    const [favoritesLoaded, setFavoritesLoaded] = useState(false);
 
    const handleSaveFavorites = async (players = starredPlayers, teamFav = isTeamFavorite) => {
        const filteredPlayers = players.filter(playerKey => playerKey.startsWith("Bournemouth"));
        
        const fav = {
            teamName: "Bournemouth",
            teamLogo: PLsoccerLogos["Bournemouth"],
            isTeamFavorite: teamFav,
            players: filteredPlayers.map(player => ({
                name: player,
                isFavorite: true
            }))
        };

         try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/favorites/save`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify(fav),
            });

        } catch(err) {
            console.error("Error saving favorites: ", err);
        }
    };

    useEffect(() => {
                const fetchFavorites = async () => {
                    try {
                        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/favorites/get?team=Bournemouth`, {
                            method: "GET",
                            headers: { "Content-Type": "application/json" },
                            credentials: "include",
                        });
            
                        if (!res.ok) {
                            console.log("No favorites found or error fetching");
                            setFavoritesLoaded(true);
                            return;
                        }
                        const data = await res.json();
            
                        // highlight team star
                        setIsTeamFavorite(data.team?.isFavorite || false);
            
                        // highlight player stars
                        const playerKeys = data.players
                            .filter(p => p.isFavorite && p.name.startsWith("Bournemouth"))
                            .map(p => p.name);  
                        setStarredPlayers(playerKeys);
                        setFavoritesLoaded(true);
        
                    } catch (err) {
                        console.error("Error fetching favorites", err);
                    }
                };
            
                fetchFavorites();
            }, []);

    return (
        <div>
            <section className="soccer-top-row">
                <section className="soccer-team-info">
                    <img
                        className="soccer-team-logo"
                        src={PLsoccerLogos["Bournemouth"]}
                        alt="AFC Bournemouth"
                    />
                    <div className="soccer-team-text">
                        <div className="soccer-title-row">
                            <h1>AFC Bournemouth</h1>
                            <button
                                type="button"
                                className="soccer-favorite-btn"
                                onClick={() => {
                                    const newVal = !isTeamFavorite;
                                    setIsTeamFavorite(newVal);
                                    handleSaveFavorites(starredPlayers, newVal); 
                                }}
                                aria-label="Toggle favorite"
                            >
                                {isTeamFavorite ? '★' : '☆'}
                            </button>
                        </div>
                        <p><span className="soccer-label">Record:</span> <Record name="Bournemouth" /></p>
                        <p><span className="soccer-label">Stadium:</span> The Vitality Stadium</p>
                        <p><span className="soccer-label">Head Coach / Manager:</span> Andoni Iraola</p>
                        <p><span className="soccer-label">Assistant Staff:</span> Tommy Elphick, Shaun Cooper</p>
                    </div>
                </section>
            </section>

            <div className="soccer-team-content">
                <section className="soccer-left-content">
                    <h2>Roster</h2>
                    {favoritesLoaded && (
                    <RosterBox
                        teamName="Bournemouth"
                        sport="soccer"
                        favoritePlayers={starredPlayers || []} 
                        onFavoriteChange={(updatedPlayers) => {
                            setStarredPlayers(updatedPlayers);
                            handleSaveFavorites(updatedPlayers, isTeamFavorite);
                        }}
                    />
                    )}
                </section>

                <section className="soccer-middle-content">
                    <h2>Recent Matches</h2>
                    <RecentBox teamName="Bournemouth" />

                    <h2>Upcoming Matches</h2>
                    <ScheduleBox teamName="Bournemouth" />
                </section>

                <section className="soccer-right-content">
                    <h2>Fun Facts</h2>
                    <div className="soccer-box">
                        <p>• Rose from the 4th division to Premier League in just six seasons (2010-2015)</p>
                        <br />
                        <p>• Holds the record for the fastest hat trick in the English soccer leagues, hattrick in 2 minutes and 21 seconds</p>
                        <br />
                        <p>• Their nickname “Cherries” is derived from the fact that their stadium was near many cherry trees</p>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default BournemouthHome;